import React, { useEffect, useState } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { useConfirm } from "material-ui-confirm";
import { useSnackbar } from "notistack";
import DataGridCrudComponent from "../../../Components/Forms/DataGridCrudComponent";
import { UsuarioNaoConformidadeService } from "../../../Services/Cadastros/Usuario/UsuarioNaoConformidadeService";
import { UsuarioNaoConformidade } from "../../../Models/Cadastros/Usuario/UsuarioNaoConformidade";
import InlineSearchComponent from "../../../Components/Forms/InlineSearchComponent";

const UsuarioNaoConformidadePartial = (props: any) => {
    const [usuarioNaoConformidade, setUsuarioNaoConformidade] = useState<UsuarioNaoConformidade>(new UsuarioNaoConformidade());
    const [usuarioNaoConformidades, setUsuarioNaoConformidades] = useState<any[]>([]);
    const confirm = useConfirm();
    const { enqueueSnackbar } = useSnackbar();
    const usuarioNaoConformidadeService = new UsuarioNaoConformidadeService()

    const usuarioNaoConformidadeColunas: GridColDef[] = [
        { field: 'nao_conformidade_nome', headerName: 'Não Conformidade', minWidth: 200, flex: 0.2, },
    ];

    useEffect(() => {
        if (props.usuario == null) {
            return;
        }

        loadDados();
    }, [props.usuario]);

    function loadDados() {
        props.usuario.usuario_nao_conformidades = props.usuario.usuario_nao_conformidades ?? [];
        setUsuarioNaoConformidades(usuarioNaoConformidadeService.selecionarValidos(props.usuario.usuario_nao_conformidades));
    }

    function adicionar() {
        let response = usuarioNaoConformidadeService.salvar(usuarioNaoConformidade, props.usuario.usuario_nao_conformidades);
        if (!response.valid) {
            enqueueSnackbar(response.message);
            return;
        }

        props.usuario.usuario_nao_conformidades = response.entities;
        loadDados();
        cancelar();
        enqueueSnackbar('Não Conformidade inserida com sucesso!', {variant: 'success'});
    }

    async function apagar(id: any) {
        await confirm({ title: "Deseja realmente apagar este registro?" });

        let response = usuarioNaoConformidadeService.apagar(id, props.usuario.usuario_nao_conformidades);
        if (!response.valid) {
            enqueueSnackbar(response.message);
            return;
        }

        props.usuario.usuario_nao_conformidades = response.entities;
        loadDados();
        enqueueSnackbar('Não Conformidade apagada com sucesso!', {variant: 'success'});
    }

    function cancelar() {
        setUsuarioNaoConformidade(new UsuarioNaoConformidade());
    }

    return (
        <div>
            <DataGridCrudComponent
                model={usuarioNaoConformidade}
                save={adicionar}
                cancel={cancelar}
                labelSave='Salvar'
                gridDelete={apagar}
                gridRows={usuarioNaoConformidades}
                gridColumns={usuarioNaoConformidadeColunas}
                minWidthGridActionsArea={130}
                gridHideFooter={true}
                gridHideEdit={true}
                gridFieldId='id'
                gridHeight={500}>
                <div className="col-md-4 mb-3">
                    <InlineSearchComponent
                        id='usuario_nao_conformidade_id'
                        label='Não Conformidades'
                        urlApi='buscaNaoConformidades'
                        valueField='id'
                        textField='tipo'
                        model={usuarioNaoConformidade}
                        modelField='nao_conformidade_id'
                        modelFieldName='nao_conformidade_nome' />
                </div>
            </DataGridCrudComponent>
        </div>
    );
}

export default UsuarioNaoConformidadePartial;